/**
 * Search Selectors - Zustand Store
 * Atomic selectors for search slice to minimize re-renders
 *
 * Usage:
 * ```ts
 * const selectedPlaceTypes = useGeoMarkupStore(selectSelectedPlaceTypes);
 * const recentSearches = useGeoMarkupStore(selectRecentSearches);
 * ```
 */

import type { GeoMarkupStore } from '../index';

export const selectSelectedPlaceTypes = (state: GeoMarkupStore) =>
  state.search.selectedPlaceTypes;

export const selectUseLocationPriority = (state: GeoMarkupStore) =>
  state.search.useLocationPriority;

export const selectRecentSearches = (state: GeoMarkupStore) =>
  state.search.recentSearches;
